import { render, staticRenderFns } from "./YourValuation.vue?vue&type=template&id=1f16dc72"
import script from "./YourValuation.vue?vue&type=script&lang=js"
export * from "./YourValuation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports